export enum FeatureFlags {
  ADMINISTRATION_NAVIGATION = 'administration-navigation',
  DISTRIBUTION_SETTINGS_PLATFORM = 'distribution-settings-platform',
  EDIT_STOCKPOOL_EXTRACTION = 'edit-stockpool-extraction',
  IDENTITY_MANAGEMENT = 'identity-management',
  ORDER_PAYMENT_REPORT = 'order-payment-report',
  PAYMENTS_INTEGRATION = 'payments-integration',
  PROMOTIONS_DEPLOYMENT = 'promotions-deployment',
  REPORT_SCHEDULES = 'report-schedules',
  REPORTS_FINANCE_T2 = 'reports-finance-t2',
  USER_ARCHIVE = 'user-archive',
}
